import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { WebUIThemeProvider } from 'web-ui-components/lib/utilities/themes';
import createStore from '../../../store/index';
import sessionPropTypes from '../../../states/session/propTypes';
import envConfigPropTypes from '../../../states/envConfig/propTypes';
import LayoutContainer from '../LayoutContainer/LayoutContainer';
import copPropTypes from '../../states/propTypes';

class App extends Component {
	constructor(props) {
		super(props);
		const { session, envConfig, user, cop, initStore } = props;

		// Used when cop is called outside this repo and we don't already have a redux store
		if (initStore) {
			this.store = createStore({
				session,
				envConfig,
				user,
				cop,
			});
		}
	}

	render() {
		const {
			envConfig,
			initStore,
			cop,
			isPayeeSaved,
			isSingleUse,
			copCheckTriggered,
			handleComplete,
			handleCancel,
			handleEdit,
			payeeId,
			handleKeepAsIs,
			sessionCOPChecks,
		} = this.props;

		return initStore ? (
			<Provider store={this.store}>
				<div className="web-ui-components">
					<WebUIThemeProvider brandID={envConfig.brandId === 'DYB' ? 'B' : envConfig.brandId}>
						<LayoutContainer
							isPayeeSaved={isPayeeSaved}
							isSingleUse={isSingleUse}
							copCheckTriggered={copCheckTriggered}
							copDetails={cop}
							handleComplete={handleComplete}
							handleCancel={handleCancel}
							handleEdit={handleEdit}
							handleKeepAsIs={handleKeepAsIs}
							payeeId={payeeId}
							sessionCOPChecks={sessionCOPChecks}
						/>
					</WebUIThemeProvider>
				</div>
			</Provider>
		) : (
			<LayoutContainer
				copCheckTriggered={copCheckTriggered}
				copDetails={cop}
				isPayeeSaved={isPayeeSaved}
				isSingleUse={isSingleUse}
				handleComplete={handleComplete}
				handleCancel={handleCancel}
				handleEdit={handleEdit}
				handleKeepAsIs={handleKeepAsIs}
				payeeId={payeeId}
				sessionCOPChecks={sessionCOPChecks}
			/>
		);
	}
}

App.defaultProps = {
	initStore: true,
};

App.propTypes = {
	session: PropTypes.shape(sessionPropTypes).isRequired,
	sessionCOPChecks: PropTypes.object,
	envConfig: PropTypes.shape(envConfigPropTypes).isRequired,
	user: PropTypes.shape({ id: PropTypes.string }),
	cop: PropTypes.shape(copPropTypes).isRequired,
	initStore: PropTypes.bool,
	copCheckTriggered: PropTypes.func,
	handleComplete: PropTypes.func,
	handleCancel: PropTypes.func,
	handleEdit: PropTypes.func,
	payeeId: PropTypes.string,
	isPayeeSaved: PropTypes.bool,
	isSingleUse: PropTypes.bool,
};

export default App;
